import React, { MutableRefObject, useRef } from "react";
import SignaturePad from "react-signature-canvas";

import ErrorText from "../ErrorText/ErrorText";

import { SignatureCanvasProp } from "./types";

import "./styles.scss";

const SignatureCanvas = ({
  className,
  onDrawEnd,
  error,
}: SignatureCanvasProp) => {
  const signaturePadRef = useRef() as MutableRefObject<SignaturePad>;

  return (
    <>
      <SignaturePad
        ref={signaturePadRef}
        canvasProps={{
          className: `${className ?? ""} signature-canvas`,
        }}
        onEnd={() => onDrawEnd(signaturePadRef?.current)}
      />
      {error ? <ErrorText error={error} /> : null}
    </>
  );
};

export default SignatureCanvas;
